/**
 * @typedef {String} module:DeviceService.ServiceStates
 * @readonly
 * @description A state that services can be in
 * @property {String} autoRenew "autoRenew"
 * @property {String} expires "expires"
 * @property {String} expired "expired"
 * @property {String} aboutToExpire "aboutToExpire"
 * @property {String} trialExpires "trialExpires"
 * @property {String} trialExpired "trialExpired"
 * @property {String} trialAboutToExpire "trialAboutToExpire"
 * @property {String} freeExpires "freeExpires"
 * @property {String} freeExpired "freeExpired"
 * @property {String} freeAboutToExpire "freeAboutToExpire"
 * @property {String} freeService "freeService"
 * @property {String} singleCamSub "singleCamSub"
 * @property {String} voucher "voucher"
 */
const serviceStates = Object.freeze({
    autoRenew: 'autoRenew',
    expires: 'expires',
    expired: 'expired',
    aboutToExpire: 'aboutToExpire',
    trialExpires: 'trialExpires',
    trialExpired: 'trialExpired',
    trialAboutToExpire: 'trialAboutToExpire',
    freeExpires: 'freeExpires',
    freeExpired: 'freeExpired',
    freeAboutToExpire: 'freeAboutToExpire',
    freeService: 'freeService',
    singleCamSub: 'singleCamSub',
    voucher: 'voucher'
});

export default serviceStates;
